import StackModal from './Components/StackModal';
import FormModal from './Components/FormModal';
import LargeModal from './Components/LargeModal';
import FullModal from './Components/FullModal';
import {Modal, ModalProps} from 'antd';

export interface ProModalProps extends ModalProps {
    onOk?(): void;
    onCancel?(): void;
}

export const ProModal = Object.assign(Modal, {
    Stack: StackModal,
    Form: FormModal,
    Large: LargeModal,
    Full: FullModal,
});
